export const containerSleevesHeroContent = {
  badge: 'Food Container Solution',
  scriptTitle: 'Our Premium',
  mainTitleLines: ['Container', 'Sleeves'],
  kicker: 'Insulation & Moisture Protection',
  descriptions: [
    'Premium and protective, our container sleeve paper combines thermal insulation with moisture resistance for takeaway meals and food service packaging applications.',
    'From cloud kitchens and QSR brands to catering operations, our sleeves preserve food temperature, support custom printing, and strengthen reliable bulk supply.',
  ],
  features: [
    'Thermal Insulation',
    'Moisture Barrier',
    'Custom Printing',
    'Food Grade Safe',
  ],
  images: [
    {
      src: '/images/products/Container-Sleeves1 (1).png',
      alt: 'Container sleeve paper material',
    },
    {
      src: '/images/products/Container-Sleeves1 (3).png',
      alt: 'Container sleeve product showcase',
    },
    {
      src: '/images/products/Container-Sleeves1 (2).png',
      alt: 'Container sleeve manufacturing',
    },
  ],
  stampLabel: 'Insulated',
};
